/* global features */  


// passes CSS breakpoints into global js var for limiting js features on screensize
var breakpoint = {};
breakpoint.refreshValue = function () {
  this.value = window.getComputedStyle(
    document.querySelector('body'),
    ':before'
  ).getPropertyValue('content').replace(/\"|\'/g, '');
};

breakpoint.refreshValue();

jQuery(window).on("debouncedresize", function( event ) {
    breakpoint.refreshValue();
});

